import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ContentProvider } from "@/context/ContentContext";
import { MediaProvider } from "@/context/MediaContext";
import SiteNav from "@/components/public/SiteNav";
import Footer from "@/components/landing/Footer";
import ChatWidget from "@/components/landing/ChatWidget";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ContentProvider>
      <MediaProvider>
        <SiteNav />
        <main>
          <Outlet />
        </main>
        <Footer />
        <ChatWidget />
      </MediaProvider>
    </ContentProvider>
  );
}
